import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { getEndpoint } from './httpWRM'
import { BaseResponse } from 'src/types'

export const deleteInstrumento = (idOperacion: number, idOperacionInstrumento: number): Promise<BaseResponse> => {
    const endpoint = getEndpoint(`${idOperacion}/limites/${idOperacionInstrumento}`)

    return HttpAxiosRequest.delete(endpoint)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
